import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column kn-width-full" }
const _hoisted_2 = { class: "p-d-flex p-flex-row p-mt-2" }
const _hoisted_3 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_4 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-float-label p-as-end p-ml-auto" }
const _hoisted_7 = {
  for: "rows",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-mt-auto p-ml-auto p-mb-3 p-mr-3" }
const _hoisted_9 = { class: "p-m-2" }
const _hoisted_10 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Menu = _resolveComponent("Menu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-col-12 kn-flex-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.drillTru.title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("b", null, _toDisplayString(_ctx.$t('documentExecution.olap.drillTru.selectLevels')) + ":", 1),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dtTree, (parent, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "p-d-flex p-flex-column"
            }, [
              _createVNode(_component_Button, {
                class: "p-button-text p-button-plain",
                label: parent.caption,
                onClick: ($event: any) => (_ctx.showMenu($event, parent))
              }, null, 8, ["label", "onClick"])
            ]))
          }), 128)),
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary p-ml-auto",
            label: _ctx.$t('documentExecution.olap.drillTru.clearAll'),
            onClick: _ctx.clearLevels
          }, null, 8, ["label", "onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      value: _ctx.dtData,
      id: "olap-custom-views-table",
      class: "p-datatable-sm kn-table p-m-2 olap-drill-through-table",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
      paginator: _ctx.drillData.length > 20,
      rows: 18,
      responsiveLayout: "stack",
      breakpoint: "600px",
      stripedRows: "true",
      rowHover: "true"
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              id: "rows",
              class: "kn-material-input",
              modelValue: _ctx.maxRows,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.maxRows = $event)),
              options: _ctx.maxRowsOptions,
              style: _ctx.dtDescriptor.style.dropdown,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('rowsChanged', _ctx.maxRows)))
            }, null, 8, ["modelValue", "options", "style"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.olap.drillTru.maxRows')), 1)
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableColumns, (column, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            class: "kn-truncated",
            key: index,
            field: column.name,
            header: _ctx.$t(column.label),
            sortable: true
          }, null, 8, ["field", "header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "filters", "paginator"]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary p-mx-2",
        label: _ctx.$t('common.export'),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportDrill(_ctx.dtData, 'DrillTrough Table', true)))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.apply'),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('drill')))
      }, null, 8, ["label"])
    ]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, {
      item: _withCtx(({item}) => [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_Checkbox, {
            modelValue: item.checked,
            "onUpdate:modelValue": ($event: any) => (item.checked = $event),
            binary: true,
            onClick: ($event: any) => (_ctx.$emit('checkCheckboxes', item, _ctx.dtAssociatedLevels))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
          _createVNode("text", _hoisted_10, _toDisplayString(item.caption), 1)
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}